import { useOrdersApi } from '@api/orders/order/orders.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useOrdersApi().fetchOrders()
})
